"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var React = _interopRequireWildcard(require("react"));
var _Translations = require("react-platform-components/dist/Translations");
var _reactRedux = require("react-redux");
var _qs = _interopRequireDefault(require("qs"));
var _config = require("../config");
var _ChangePasswordTab = _interopRequireDefault(require("./tabs/ChangePasswordTab"));
var _CreditCards = _interopRequireDefault(require("./tabs/CreditCards"));
var _UserInfo = _interopRequireDefault(require("./tabs/UserInfo"));
var _UpdateStripePaymentMethod = _interopRequireDefault(require("./tabs/UpdateStripePaymentMethod"));
var _DeleteAccountTab = require("./tabs/DeleteAccountTab");
var _reactUse = require("react-use");
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Purchase;
try {
  Purchase = require('react-platform-purchase/dist/Purchase/PurchaseConfig');
} catch (error) {}
var AddressOfUser;
try {
  AddressOfUser = require('react-platform-address-of-user/dist/AddressOfUser/AddressOfUser').default;
} catch (error) {}
var MangopayAccountTab;
try {
  MangopayAccountTab = require('react-platform-mangopay/dist/Mangopay/UserProfile/MangopayAccountTab').MangopayAccountTab;
} catch (error) {}
var useStripe = false;
try {
  // we check here if we use stripe for the payment or not
  var PAYMENT_METHOD = require('react-platform-shoppingcart/dist/config/index').PAYMENT_METHOD;
  useStripe = PAYMENT_METHOD === 'STRIPE' ? true : false;
} catch (error) {}
var styles = function styles(theme) {
  var _theme$palette, _theme$palette$custom, _theme$palette2, _theme$palette2$custo;
  return {
    avatar: {
      backgroundColor: '#3b3b3b',
      color: '#fff',
      fontSize: 55,
      height: 96,
      textDecoration: 'none',
      width: 96
    },
    header: _objectSpread({
      backgroundColor: "#f5f5f5",
      backgroundImage: "url(\"".concat(_config.STATIC_PATH, "/assets/images/backgrounds/header-bg.png\")"),
      backgroundSize: 'cover',
      color: '#fff',
      display: 'flex',
      minHeight: '10vh',
      alignItems: "center",
      justifyContent: "center"
    }, (_theme$palette = theme.palette) !== null && _theme$palette !== void 0 && (_theme$palette$custom = _theme$palette.custom) !== null && _theme$palette$custom !== void 0 && _theme$palette$custom.headerOfBaseContainer ? (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : (_theme$palette2$custo = _theme$palette2.custom) === null || _theme$palette2$custo === void 0 ? void 0 : _theme$palette2$custo.headerOfBaseContainer : null),
    paper: {
      width: "100%",
      flexGrow: "1"
    }
  };
};
function Profile(props) {
  var _user$stripe_extensio;
  var history = (0, _reactRouterDom.useHistory)();
  (0, _reactUse.useTitle)(props.intl.formatMessage({
    id: "profile page title",
    defaultMessage: "profile page title"
  }));
  var user = (0, _reactRedux.useSelector)(function (state) {
    return state.auth.user;
  });
  var _React$useState = React.useState({
      value: _qs.default.parse(props.history.location.search, {
        ignoreQueryPrefix: true
      }).tab || 'userinfo'
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    state = _React$useState2[0],
    setState = _React$useState2[1];
  React.useEffect(function () {
    if (props.match.path === '/mangopay-info') {
      setState({
        value: 'mangopay_info'
      });
    }
  }, []);
  var handlerTabChanged = function handlerTabChanged(event, value) {
    setState({
      value: value
    });
    history.push({
      search: "?tab=".concat(value)
    });
  };
  var classes = props.classes;
  var UserInfoComponent = props.UserInfo || _UserInfo.default;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "p-12 pt-80 flex flex-1 flex-col items-center justify-center md:flex-row md:items-end ".concat(classes.header)
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 flex-col items-center justify-center md:flex-row md:items-center md:justify-start white"
  }, /*#__PURE__*/React.createElement(_core.Typography, {
    className: "md:ml-24 white",
    variant: "h4"
  }, _config.NAME_ORDER_IN_CHAT === "P" ? user.first_name + " " + user.last_name : user.name)), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-end"
  })), /*#__PURE__*/React.createElement(_core.Paper, {
    className: classes.paper
  }, /*#__PURE__*/React.createElement(_core.AppBar, {
    position: "static",
    color: "default"
  }, /*#__PURE__*/React.createElement(_core.Tabs, {
    value: state.value,
    onChange: handlerTabChanged,
    indicatorColor: _config.USE_SECONDARY_COLOR ? "secondary" : "primary",
    textColor: _config.USE_SECONDARY_COLOR ? "secondary" : "primary",
    scrollButtons: "on",
    variant: "scrollable",
    className: "md:mx-8",
    style: {
      width: window.innerWidth < 600 && "100vw"
    }
  }, /*#__PURE__*/React.createElement(_core.Tab, {
    className: "h-16",
    label: /*#__PURE__*/React.createElement(_Translations.IntlMessages, {
      id: "Informations utilisateur",
      defaultMessage: "Informations utilisateur"
    }),
    value: "userinfo"
  }), /*#__PURE__*/React.createElement(_core.Tab, {
    className: "h-16",
    label: /*#__PURE__*/React.createElement(_Translations.IntlMessages, {
      id: "Mot de passe",
      defaultMessage: "Mot de passe"
    }),
    value: "password"
  }), Purchase && !_config.USE_STRIPE_PURSHACE && /*#__PURE__*/React.createElement(_core.Tab, {
    className: "h-16",
    label: /*#__PURE__*/React.createElement(_Translations.IntlMessages, {
      id: "Mangopay Info",
      defaultMessage: "Mangopay Info"
    }),
    value: "mangopay_info"
  }), _config.USE_CREDIT_CARDS && /*#__PURE__*/React.createElement(_core.Tab, {
    className: "h-16",
    label: /*#__PURE__*/React.createElement(_Translations.IntlMessages, {
      id: "Cartes de cr\xE9dit",
      defaultMessage: "Cartes de cr\xE9dit"
    }),
    value: "cards"
  }), AddressOfUser && /*#__PURE__*/React.createElement(_core.Tab, {
    className: "h-16",
    label: /*#__PURE__*/React.createElement(_Translations.IntlMessages, {
      id: "Addresses",
      defaultMessage: "Addresses"
    }),
    value: "address_of_user"
  }), useStripe && (user === null || user === void 0 ? void 0 : (_user$stripe_extensio = user.stripe_extension) === null || _user$stripe_extensio === void 0 ? void 0 : _user$stripe_extensio.default_payment_method) && /*#__PURE__*/React.createElement(_core.Tab, {
    className: "h-16",
    label: /*#__PURE__*/React.createElement(_Translations.IntlMessages, {
      id: "Update payement method",
      defaultMessage: "Update payement method"
    }),
    value: "update_stripe_payment_methods"
  }), /*#__PURE__*/React.createElement(_core.Tab, {
    className: "h-16",
    label: /*#__PURE__*/React.createElement(_Translations.IntlMessages, {
      id: "DeleteAccountTab",
      defaultMessage: "DeleteAccountTab"
    }),
    value: "deleteaccount"
  })))), state.value === 'userinfo' ? /*#__PURE__*/React.createElement(UserInfoComponent, null) : null, state.value === 'password' ? /*#__PURE__*/React.createElement(_ChangePasswordTab.default, {
    history: props.history
  }) : null, state.value === 'cards' ? /*#__PURE__*/React.createElement(_CreditCards.default, null) : null, state.value === 'mangopay_info' ? /*#__PURE__*/React.createElement(_core.Paper, {
    className: "m-8"
  }, /*#__PURE__*/React.createElement(MangopayAccountTab, null)) : null, state.value === 'address_of_user' ? /*#__PURE__*/React.createElement(AddressOfUser, null) : null, state.value === 'deleteaccount' ? /*#__PURE__*/React.createElement(_DeleteAccountTab.DeleteAccountTab, null) : null, useStripe && state.value === 'update_stripe_payment_methods' ? /*#__PURE__*/React.createElement(_UpdateStripePaymentMethod.default, null) : null);
}
var _default = (0, _styles.withStyles)(styles)((0, _Translations.injectIntl)(Profile));
exports.default = _default;